import { useState } from 'react';
import classes from './ReportResult.module.css';
import Ratings from './Ratings';
import RoleplayRating from 'features/roleplay/Components/Common/RoleplayRating/RoleplayRating';

const SkillRatings = (props) => {
  const [showDetailedFeedback, setShowDetailedFeedback] = useState(false);

  const getBorderColor = (number_of_stars) => {
    if (number_of_stars >= 0 && number_of_stars <= 2) return '#F0CBCB';
    if (number_of_stars === 4 || number_of_stars === 5) return 'rgba(150, 225, 198, 1)';
    if (number_of_stars === 3) return '#E1DF96';
    return '#eceff1';
  };

  if (showDetailedFeedback) {
    return (
      <div>
        <Ratings {...props} title="Skill Ratings"/>
        <div className={classes.feedbackContainer}>
          <button onClick={() => setShowDetailedFeedback(false)}>See less</button>
        </div>
      </div>
    );
  }

  return (
    <div>
      <h4>📚 Skill Ratings</h4>
      {props.rating_criteria?.map?.((c) => (
        <div
          className={classes.ratingContainer}
          key={c?.uuid}
          style={{ border: `1px solid ${props.onlyRead ? getBorderColor(c?.stars)  : getBorderColor(c?.rating)}` }}
        >
          <div className={classes.criteriaContainer}>
            <b className="heading6">{props.onlyRead ? c?.rating_criteria?.name : c?.name}</b>
            {props.onlyRead ? (
              <RoleplayRating withTooltip stars={c?.stars ?? 0} />
            ) : (
              <RoleplayRating withTooltip stars={props.status_ai === 'SUCCEEDED' ? c?.rating : 0} />
            )}
          </div>
        </div>
      ))}
      <div className={classes.feedbackContainer}>
        <button onClick={() => setShowDetailedFeedback(true)}>See detailed Feedback</button>
        <svg
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            fill-rule="evenodd"
            d="M18.425 10.271C19.499 8.967 18.57 7 16.88 7H7.12c-1.69 0-2.618 1.967-1.544 3.271l4.881 5.927a2 2 0 0 0 3.088 0l4.88-5.927Z"
            clip-rule="evenodd"
          />
        </svg>
      </div>
    </div>
  );
};

export default SkillRatings;
